import {
  LayoutDashboard,
  Calendar,
  Settings,
  // Link2, — item de menu comentado (spec r4-08)
  // BarChart2, — icone da antiga "Analise de Progresso", fundida na r6-29
  // BookOpen, — item de menu comentado (spec r4-08)
  // Repeat, — item de menu comentado (spec r4-08)
  // ClipboardCheck, — item de menu comentado (spec r4-08)
  // Lightbulb, — item de menu comentado (spec r4-08)
  // CreditCard, — item de menu comentado (spec r4-08)
  PlayCircle,
  Video,
  MessageCircle,
  // TrendingUp, — item de menu comentado (spec r4-08)
  PenLine,
  Target,
  FileText,
  Handshake,
  PieChart,
  Compass,
  ClipboardList,
  FileSignature,
  type LucideIcon
} from 'lucide-react'
import { MANUAL_COPY, MANUAL_ROUTE } from '@/lib/copy/manual'
import { ANALYSIS_SECTION } from '@/lib/copy/analysis'
import { APPROVAL_CENTER_TITLE, EXAM_PROCESSES_ROUTE } from '@/lib/copy/examProcesses'
import type { PlanFeatureKey } from '@/types/api'

// Fonte unica do menu lateral (desktop e drawer mobile leem o mesmo array — r6-25 R2).
// Modulo puro, sem JSX, para a ordem ser testavel no vitest (ambiente node).
export interface NavItem {
  icon: LucideIcon
  label: string
  path: string
  requiresIntegration?: 'medway' | 'medcof' | 'any' | null
  /**
   * r7-25: feature do plano que libera o item. Sem ela o item some do menu — ou, se o
   * plano pedir (`show_locked_features`), aparece bloqueado (`locked`).
   */
  feature?: PlanFeatureKey
  badge?: number
  /** Atalho para um trecho de outra pagina: nao fica marcado como pagina atual. */
  shortcut?: boolean
}

/** Item ja resolvido contra o plano: `locked` = fora do plano, exibido com cadeado. */
export interface PlanNavItem extends NavItem {
  locked: boolean
}

/** Fora de `navItems`: nao depende do plano, so aparece para quem assinou o contrato. */
export const SIGNED_CONTRACT_NAV_ITEM: PlanNavItem = {
  icon: FileSignature,
  label: 'Meu contrato',
  path: '/app/configuracoes#privacidade',
  shortcut: true,
  locked: false,
}

export const navItems: readonly NavItem[] = [
  // Dashboard em primeiro (r6-25, Pedro: "a primeira coisa que o cara vai ver e dashboard").
  { icon: LayoutDashboard, label: 'Dashboard', path: '/app/dashboard', feature: 'dashboard' },
  { icon: PenLine, label: MANUAL_COPY.title, path: MANUAL_ROUTE, feature: 'registro_estudos' },
  { icon: Target, label: 'Jornada', path: '/app/jornada', feature: 'jornada' },
  // De volta ao menu na r6-06 (Pedro: "calendário é obrigatório para lançar").
  { icon: Calendar, label: 'Calendário', path: '/app/calendario', feature: 'calendario' },
  // HERMES: processos seletivos das instituicoes-alvo + exames nacionais, com o nome que o
  // padrinho ja ve na area dele (Central do Aprovado). Feature do plano desde 2026-10-13.
  { icon: ClipboardList, label: APPROVAL_CENTER_TITLE, path: EXAM_PROCESSES_ROUTE, feature: 'central_do_aprovado' },
  { icon: PieChart, label: 'Análise de Métricas', path: '/app/analise-metricas', feature: 'analise_metricas' },
  // r6-29: "Guia Estatistico" e "Analise de Progresso" eram dois itens vizinhos que o
  // aluno nao distinguia — viraram abas de uma entrada so. O `requiresIntegration: 'any'`
  // do segundo saiu junto (R4): `CoveragePanel` conta REGISTRO manual e nao depende de
  // Medway/MedCof, entao o gating so escondia do menu uma tela que a URL servia normal.
  { icon: Compass, label: ANALYSIS_SECTION.label, path: ANALYSIS_SECTION.path, feature: 'analise_estatistica' },
  // Estudos, Revisões, Recomendações, Simulados e Prevalência saíram do menu (spec r4-08,
  // complemento) — são as telas das integrações Medway/MedCof, que estão sendo
  // descontinuadas. Só do menu: rotas e páginas continuam alcançáveis pela URL.
  // { icon: BookOpen, label: 'Estudos', path: '/app/estudos', requiresIntegration: 'any' },
  // { icon: Repeat, label: 'Revisões', path: '/app/revisoes', requiresIntegration: 'any' },
  // { icon: Lightbulb, label: 'Recomendações', path: '/app/revisoes-recomendadas', requiresIntegration: 'any' },
  // { icon: ClipboardCheck, label: 'Simulados', path: '/app/simulados-integracoes', requiresIntegration: 'any' },
  // { icon: TrendingUp, label: 'Prevalência', path: '/app/prevalencia', requiresIntegration: 'any' },
  // Sem `requiresIntegration`: as provas vem do banco (`exam_attempts#available_exams`), nao
  // de Medway/MedCof. Quem tem `provas_integra` no plano ve o item, com ou sem integracao.
  { icon: FileText, label: 'Provas na Íntegra', path: '/app/provas', feature: 'provas_integra' },
  { icon: PlayCircle, label: 'Vídeo Aulas', path: '/app/video-aulas', feature: 'video_aulas' },
  // ZOOM: o plano libera a area; dentro dela o aluno so ve as aulas em que o admin o
  // incluiu. A lista vazia explica que nao ha aula.
  { icon: Video, label: 'Reuniões ao vivo', path: '/app/aulas-ao-vivo', feature: 'aulas_ao_vivo' },
  // Assinatura e Integrações saíram do menu (spec r4-08) — só do menu: as rotas continuam
  // registradas em `routes/index.tsx` e as páginas continuam alcançáveis pela URL. Decisão
  // do cliente: esconder, não remover. Para voltar, descomente aqui e os ícones no import.
  { icon: Handshake, label: 'Match Hunter', path: '/app/social/match-hunter', feature: 'match_hunter' },
  { icon: MessageCircle, label: 'Conversas', path: '/app/social/conversations', feature: 'conversas' },
  // { icon: CreditCard, label: 'Assinatura', path: '/app/assinatura' },
  // { icon: Link2, label: 'Integrações', path: '/app/integracoes' },
  { icon: Settings, label: 'Configurações', path: '/app/configuracoes' },
]

/**
 * r7-25: aplica o plano ao menu. `hasFeature` vem de `lib/planFeatures` (le o
 * `plan_access` do `/auth/me`); item sem `feature` (Configuracoes) fica sempre.
 * O que o plano nao libera some, ou — com `showLocked` — fica no lugar marcado `locked`
 * (o Sidebar o desenha sem link, apagado e com cadeado).
 */
export function filterNavItemsByPlan(
  items: readonly NavItem[],
  hasFeature: (feature: PlanFeatureKey) => boolean,
  showLocked = false,
): PlanNavItem[] {
  return items
    .map((item) => ({ ...item, locked: Boolean(item.feature) && !hasFeature(item.feature as PlanFeatureKey) }))
    .filter((item) => showLocked || !item.locked)
}

/** Poe "Meu contrato" logo antes de Configuracoes, o ultimo item do menu. */
export function withSignedContractItem(items: readonly PlanNavItem[], hasSignedContract: boolean): PlanNavItem[] {
  if (!hasSignedContract) return [...items]
  return [...items.slice(0, -1), SIGNED_CONTRACT_NAV_ITEM, ...items.slice(-1)]
}
